export const msToFullTime = (duration, digitalFormat = false) => {
  let seconds = Math.max(0, Math.floor((duration / 1000) % 60));
  let minutes = Math.max(0, Math.floor((duration / (1000 * 60)) % 60));
  let hours = Math.max(0, Math.floor((duration / (1000 * 60 * 60)) % 24));

  if (digitalFormat) {
    seconds = seconds < 10 ? "0" + seconds : seconds;
    minutes = minutes < 10 ? "0" + minutes : minutes;
  }

  return digitalFormat
    ? `${minutes}:${seconds}`
    : `${hours}h ${minutes}m ${seconds}s`;
};

export const getDateFromUtcString = (dateString) => new Date(dateString + "Z");

export const getFormattedDateStringFromDateString = (dateString) =>
  getDateFromUtcString(dateString).toLocaleString();

export const getFormattedDateStringFromDateObject = (dateObj) =>
  dateObj.toLocaleString();

export const getForumPostPrettyDate = (dateString) =>
  getPrettyDateWithPrefix("Posted", dateString);

export const getScenarioPrettyDate = (dateString) =>
  getPrettyDateWithPrefix("Published", dateString);

const SECONDS_IN_MIN = 60;
const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_DAY = 86400;
const SECONDS_IN_WEEK = 604800;

const getPrettyDateWithPrefix = (prefix, dateString) => {
  const pluralSuffix = (val) => (val < 2 ? "" : "s");
  const buildReturnString = (valueOfTime, unitOfTime) => {
    return `${prefix} ${Math.floor(valueOfTime)} ${unitOfTime}${pluralSuffix(
      valueOfTime
    )} ago`;
  };

  const date = new Date(dateString + "Z");
  const seconds = Math.floor((new Date() - date) / 1000);

  let interval = seconds / SECONDS_IN_WEEK;
  if (interval > 4) {
    let options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return prefix + " " + date.toLocaleString(undefined, options);
  } else if (interval > 1) {
    return buildReturnString(interval, "week");
  }

  interval = seconds / SECONDS_IN_DAY;
  if (interval > 1) {
    return buildReturnString(interval, "day");
  }

  interval = seconds / SECONDS_IN_HOUR;
  if (interval > 1) {
    return buildReturnString(interval, "hour");
  }

  interval = seconds / SECONDS_IN_MIN;
  if (interval > 1) {
    return buildReturnString(interval, "minute");
  }

  return "Just now";
};
